module.exports = __webpack_public_path__ + "img/job-interview.5fcc1507.svg";